import React from 'react';
import { connect } from 'react-redux';
import { getDisplayNameHOC } from 'app/utils';

const getSeatsInfo = (tickets, totalPrice, { row, columns: seats }) => {
  const sortedTickets = tickets.reduce(
    (temp, { price, description, ticketTypeCode }) => {
      if (temp.seatsDescription[ticketTypeCode]) {
        temp.seatsDescription[ticketTypeCode].amount += 1;
      } else {
        temp.seatsDescription[ticketTypeCode] = {
          title: description,
          price,
          amount: 1
        };
      }

      return temp;
    },
    {
      row,
      seats,
      seatsDescription: {}
    }
  );

  return {
    ...sortedTickets,
    seatsDescription: Object.values(sortedTickets.seatsDescription),
    totalPrice
  };
};

const getFromSession = ({ tickets, orderTotalValueInCents, ticketsInfo }) =>
  getSeatsInfo(
    tickets.map(({ ticketDetails: { ticketTypeCode, description, finalPriceInCents } }) => ({
      price: finalPriceInCents,
      description,
      ticketTypeCode
    })),

    orderTotalValueInCents,

    ticketsInfo
  );

const getFromBooking = ({ totalValueCents, tickets, ticketsInfo }) =>
  getSeatsInfo(
    tickets.map(({ priceInCents, description, ticketTypeCode }) => ({
      price: priceInCents,
      description,
      ticketTypeCode
    })),

    totalValueCents,

    ticketsInfo
  );

const selector = {
  session: ({ sessions, order }) => ({
    screenName: sessions?.session?.session?.screenName,
    isBonus: sessions?.wizard.isBonus,
    order: order ? getFromSession(order) : null
  }),

  booking: ({ bookings: { booking } }) => ({
    screenName: booking?.screenName,
    order: booking ? getFromBooking(booking) : null
  })
};

const withSelection = (type, isOrderRequired = true) => (WrappedComponent, orderData) => {
  const Selection = ({ order, ...props }) => {
    if (order)
      return (order || !isOrderRequired) && <WrappedComponent {...props} {...order} />;
    return (orderData || !isOrderRequired) && <WrappedComponent {...props} {...orderData} />;
  }

  Selection.displayName = `withSelection(${getDisplayNameHOC(WrappedComponent)})`;

  return connect(selector[type])(Selection);
};

export default withSelection;
